import Typography from 'common/src/code/ui/Typography.component';
import PropTypes from 'prop-types';
import React from 'react';

const FeatureTile = ({
	id = '',
	headline = '',
	description = '',
	icon = null,
	className = '',
	dataqa = '',
	onClick,
	...rest
}) => {
	return (
		<div
			className={`common-ui-feature-tile ${className}`}
			data-qa={dataqa}
			onClick={onClick}
			id={id}
		>
			<div className="icon-container">
				<div className={`icon icon-${icon}`}></div>
			</div>

			<div className="content">
				{headline && <Typography.H4>{headline}</Typography.H4>}
				{description && <Typography.P>{description}</Typography.P>}
			</div>

			<div className="chevron-container">
				<div className="chevron"></div>
			</div>
		</div>
	);
};

FeatureTile.propTypes = {
	// Card headline text
	headline: PropTypes.string,

	// Card description text
	description: PropTypes.string,

	// Icon name (will be used to construct path to SVG)
	icon: PropTypes.string,

	// Additional CSS class name
	className: PropTypes.string,

	// Data attribute for QA testing
	dataqa: PropTypes.string,

	// Click handler
	onClick: PropTypes.func,
};

export default FeatureTile;
